export const ROOT_EVENT_SLUG = 'omr26'
